import coachRoleIcon from "../assets/coach-role-icon.png";

/** Coach mark: circular coach illustration — used on the Home role switcher. */
export default function CoachRoleIcon({ sx, className = "", style, alt = "", ...props }) {
  const size = sx?.fontSize ?? 28;
  return (
    <img
      src={coachRoleIcon}
      alt={alt}
      className={`coach-role-icon ${className}`.trim()}
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
        display: "block",
        flexShrink: 0,
        ...style,
      }}
      {...props}
    />
  );
}
